<template>
  <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M10.8682 3.81229L10.371 0.331974C10.3302 0.0466414 9.97946 -0.0719308 9.77434 0.133197L9.05025 0.857287C8.11913 0.295598 7.06204 0 5.97506 0C2.70622 0 0.0818156 2.55848 0.000111208 5.82457C-0.00434199 6.0031 0.125433 6.15621 0.301897 6.18162L1.70679 6.38246C1.91623 6.41302 2.11107 6.24858 2.10816 6.02953C2.07903 3.87395 3.82004 2.10941 5.97506 2.10941C6.4969 2.10941 7.01258 2.21549 7.48914 2.41839L6.79116 3.11637C6.58732 3.32021 6.70301 3.67199 6.98994 3.71307L10.4703 4.21022C10.6996 4.24479 10.9011 4.04535 10.8682 3.81229Z"
        fill="currentColor"/>
    <path
        d="M11.6978 5.84558L10.294 5.64506C10.1126 5.6221 9.89264 5.77751 9.89264 6.02342C9.89264 8.15582 8.15779 9.89067 6.02539 9.89067C5.50629 9.89067 4.993 9.78562 4.5182 9.58476L5.19386 8.90909C5.3977 8.70525 5.28201 8.35347 4.99509 8.31239L1.51477 7.8149C1.28618 7.78225 1.08375 7.97828 1.11685 8.21282L1.61396 11.6932C1.65488 11.9788 2.00528 12.0966 2.21067 11.8919L2.95226 11.1507C3.8789 11.7072 4.93532 12.0001 6.02539 12.0001C9.27843 12.0001 11.9025 9.4543 11.9996 6.20436C12.0048 6.02548 11.875 5.87098 11.6978 5.84558Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconRefresh"
}
</script>

<style scoped>

</style>